import { forwardRef, type ButtonHTMLAttributes } from "react";

export type ButtonVariant = "primary" | "danger" | "default";

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  function Button({ variant = "default", className, ...rest }, ref) {
    const classes = ["qr-btn"];
    if (variant !== "default") classes.push(`qr-btn-${variant}`);
    if (className) classes.push(className);

    return <button ref={ref} className={classes.join(" ")} {...rest} />;
  },
);
